import React, { ReactElement, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Input } from 'ui/molecules/Input';
import { ListPartners } from '../List/Partners';
import { Sled2Partners } from '../../../types/Types';
import { useTranslation } from 'react-i18next';

type SearchPartnersProps = {
    partners: Sled2Partners[];
    selected: number | null;
    onSelectionChanged: React.Dispatch<React.SetStateAction<number | null>>;
};

const SearchPartners = ({ partners, selected, onSelectionChanged }: SearchPartnersProps): ReactElement => {
    const { t } = useTranslation();
    const [search, setSearch] = useState('');
    const [filteredPartners, setFilteredPartners] = useState<any[]>([]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(e.target.value);
    };

    useEffect(() => {
        setFilteredPartners(partners);
    }, [partners]);

    useEffect(() => {
        setFilteredPartners(
            partners.filter((partner) => {
                if (partner.name) return partner.name.toLowerCase().includes(search.toLowerCase());
            }),
        );
    }, [search]);

    return (
        <SearchCropsWrapper>
            <SearchInput type="text" value={search} label={t('search.label')} onChange={handleInputChange} />
            <ListWrapper>
                <ListPartners partners={filteredPartners} selected={selected} onSelectionChanged={onSelectionChanged} />
            </ListWrapper>
        </SearchCropsWrapper>
    );
};

export default SearchPartners;

const SearchCropsWrapper = styled.div`
    display: flex;
    flex: 1 1 auto;
    margin: 10px;
    flex-direction: column;
`;

const SearchInput = styled(Input)`
    margin-bottom: 15px;
`;

const ListWrapper = styled.div`
    flex: 1 1 auto;
`;
